import Bowser from 'bowser'

export const isSafari = () =>
  Bowser.getParser(window.navigator.userAgent).getBrowserName() === 'Safari'

export const isFirefox = () =>
  Bowser.getParser(window.navigator.userAgent).getBrowserName() === 'Firefox'
